export default __webpack_public_path__ + "static/media/LogoSwap.a20d503d.svg";